<!-- eslint-disable prettier/prettier -->
<template>
  <div class="wspo-form">
    <div class="wspo-form-col">
      <div class="wspo-form-headline">
        <span class="wspo-form-headline-large">Заполните форму,</span>
        <br />мы свяжемся с Вами <br />в ближайшее время
      </div>
    </div>
    <div class="wspo-form-col-2">
      <div class="wspo-form-row">
        <div class="wspo-form-col"
          v-if="context === 'main' || context === 'main-pm'">
          <Select type="cities" label="Город" :output="city && netCities.find(netCity => netCity.id === city).name
            " :onSelect="setCity" :options="netCities" :selected="city"
            :error="errors.officeCity" :required="true" />
        </div>
        <div class="wspo-form-col"
          v-if="context === 'main' || context === 'main-pm'">
          <Select type="offices" label="Турагентство" :output="feedback.office &&
            netOffices.find(netOffice => netOffice.id === feedback.office)
              .name
            " :onSelect="setOffice" :options="netOffices" :selected="city"
            :error="errors.officeName" />
        </div>
        <div class="wspo-form-col">
          <Input label="Ваше имя" :value="username" :error="errors.username"
            :required="true" :onInput="() => handleInput('username')" />

          <Input label="Ваш телефон" :value="phone" :error="errors.phone"
            :required="true" :onInput="() => handleInput('phone')" />

          <Input label="Ваш email" :value="email" :error="errors.email"
            :required="true" :onInput="() => handleInput('email')" />
        </div>
        <div class="wspo-form-col">
          <div class="wspo-form-control">
            <div class="wspo-form-label">Ваши пожелания</div>
            <textarea class="wspo-form-input wspo-form-textarea"
              @input="handleInput('adding')" :value="adding" rows="5"
              cols="30" />
          </div>
          <div class="wspo-form-control" style="flex: unset"
            v-if="context !== 'office'">
            <div class="wspo-form-checkbox wspo-icon" :class="{
              'wspo-checked': isPersonalDataChecked,
              'wspo-red': errors.personalData
            }" @click.self="setPersonalDataChecked" v-html="checkBoxLabel"
              style="margin-right: 18px;
              display: inline-block" />
          </div>
          <div class="wspo-form-control">
            <div class="wspo-form-submit"
              :class="{ 'is-disabled': isLoading(false) }" @click="submitForm"
              @keyup.enter="submitForm">
              {{
                isLoading(false) ? 'Обработка...' : 'Отправить заявку на тур'
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Input from '@/components/controls/Input.vue';
import Select from '@/components/controls/Select.vue';
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
import { invokeOnce } from '@/functions';
export default {
  name: 'Form',
  components: {
    Input,
    Select
  },
  data: () => ({
    isPersonalDataChecked: false,
    errors: {
      username: null,
      phone: null,
      email: null,
      officeCity: null,
      officeName: null
    }
  }),
  computed: {
    ...mapGetters([
      'isLoading',
      'netCities',
      'netOffices',
      'context',
      'policyPageLink'
    ]),
    ...mapState(['feedback', 'city', 'offices']),
    username() {
      return this.feedback.username;
    },
    phone() {
      return this.feedback.phone;
    },
    email() {
      return this.feedback.email;
    },
    adding() {
      return this.feedback.adding;
    },
    checkBoxLabel() {
      return `Я прочитал и согласен с
    <a
      target="_blank"
      href="${this.policyPageLink}"
      >политикой конфиденциальности</a
    >
    данного сайта по сбору и обработке персональных данных`;
    }
  },
  methods: {
    ...mapMutations(['updateFeedback', 'updateCity']),
    ...mapActions(['sendFeedback']),
    handleInput(name) {
      if (this.errors[name]) this.errors[name] = null;
      const value = window.event.target.value;
      invokeOnce(() => this.updateFeedback({ [name]: value }), 250);

      // if (this.selectedOfficeCity && name === 'officeCity')
      //   this.setOfficeCity();
      // if (this.selectedOffice && name === 'officeName') this.setOfficeName();
    },
    setCity(e) {
      e = e || window.event;
      this.updateCity(e.target.dataset.id);
      this.errors.officeCity = null;
      if (
        this.feedback.office &&
        !this.netOffices.find(
          netOffice => netOffice.id === this.feedback.office
        )
      )
        this.updateFeedback({ office: null });
    },
    setOffice(e) {
      e = e || window.event;
      this.errors.officeName = null;
      this.updateFeedback({ office: e.target.dataset.id });
    },
    setPersonalDataChecked() {
      this.isPersonalDataChecked = !this.isPersonalDataChecked;
      if (this.isPersonalDataChecked) {
        this.errors.personalData = null;
      }
    },
    checkForm() {
      if (!this.username) {
        this.errors.username = 'Укажите, пожалуйста, ваше имя';
      }
      if (this.username.length < 2) {
        this.errors.username = 'Имя должно быть не короче 2 знаков';
      }
      if (!this.phone) {
        this.errors.phone = 'Укажите, пожалуйста, ваш телефон';
      }
      if (this.context === 'main' || this.context === 'main-pm') {
        if (!this.city) {
          this.errors.officeCity = 'Укажите, пожалуйста, ваш город';
        }
        if (!this.feedback.office) {
          this.errors.officeName = 'Укажите, пожалуйста, офис продаж';
        }
      }
      if (this.phone.length < 10) {
        this.errors.phone = '10-значный номер, пример: 9267774433';
      }
      if (!this.email || !this.validEmail(this.email)) {
        this.errors.email = 'Укажите, пожалуйста, корректный адрес';
      }

      if (!this.isPersonalDataChecked) {
        this.errors.personalData = 'Подтвердите согласие';
      }

      if (Object.values(this.errors).every(value => value === null)) {
        return true;
      }
    },
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    submitForm() {
      if (!this.checkForm()) return;

      this.sendFeedback();
    }
  }
};
</script>

<style scoped>
.wspo-form {
  border-top: 8px solid var(--color-alt-5);
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  background-color: var(--color-bg);
  padding: 18px;
  flex: 1;
  min-height: 350px;
}

.wspo-form-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.wspo-form-col,
.wspo-form-col-2 {
  flex: 1 1 200px;
  min-width: 260px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.wspo-form-col-2 {
  flex: 2 2 400px;
}

.wspo-form-col .wspo-form-control {
  flex: 1 0 0;
}

.wspo-form-headline {
  align-self: flex-start;
  padding: 8px;
  font-size: 16px;
}

.wspo-form-headline-large {
  font-size: 22px;
}

.wspo-form-textarea {
  display: flex;
  flex: 2;
  padding-top: 22px;
  height: 120px;
}

.wspo-form-input-requirator {
  position: absolute;
  right: 9px;
  top: 9px;
  padding: 16px 10px 14px;
  cursor: pointer;
  pointer-events: none;
  transition: 0.3s;
}

.wspo-form-input-requirator:before {
  content: '\f069';
  color: var(--color-text);
  font-size: 12px;
}

.wspo-red,
.wspo-red:before {
  color: var(--color-second);
}

.wspo-form-input::placeholder {
  color: var(--color-text);
  font-weight: 600;
  opacity: 0.75;
}

.wspo-form-input:focus::placeholder {
  color: var(--color-alt);
}
</style>
